module.exports = __webpack_public_path__ + "static/media/pin.b2b8d185.svg";